import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Mechanics from "./pages/Mechanics/Mechanics";
import Schools from "./pages/Schools/Schools";
import Champions from "./pages/Champions/Champions";
import Qualifications from "./pages/Qualifications/Qualifications";
import Packages from "./pages/Packages/Packages";
import Facts from "./pages/Facts/Facts";
import Scoreboard from './pages/Scoreboard/Scoreboard';
import MiniGames from "./pages/Minigames/Minigames";

import "./styles/style.css";

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // or "auto"
    });

    if (location.pathname === "/") {
      document.body.classList.add("snap-page");
    } else {
      document.body.classList.remove("snap-page");
    }
  }, [location]);

  return null;
}

const App = () => {
  return (
    <Router>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <ScrollManager />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Mechanics" element={<Mechanics />} />
            <Route path="/Schools" element={<Schools />} />
            <Route path="/Champions" element={<Champions />} />
            <Route path="/Qualifications" element={<Qualifications />} />
            <Route path="/Packages" element={<Packages />} />
            <Route path="/Facts" element={<Facts />} />
            <Route path="/Scoreboard" element={<Scoreboard />} />
            <Route path="/Minigames" element={<MiniGames />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};

export default App;